import React from 'react';

/**
 * Val Dotika line-art icons: single-stroke, minimal, hand-drawn feeling.
 * All icons share stroke props (currentColor).
 */
const base = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.4, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const Skodelica = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M14 26h32v14a10 10 0 0 1-10 10H24a10 10 0 0 1-10-10z" />
      <path d="M46 30h4a6 6 0 0 1 0 12h-4" />
      <path d="M20 20c0-3 4-3 4-6M28 20c0-3 4-3 4-6M36 20c0-3 4-3 4-6" />
    </g>
  </svg>
);

export const Vejica = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M14 50c0-14 8-30 34-36" />
      <path d="M28 30c-1-4 1-8 6-9M32 24c-1-4 1-8 6-9M36 18c-1-4 1-8 6-9M22 40c-1-4 1-8 6-9M28 44c-1-4 1-8 6-9" />
    </g>
  </svg>
);

export const Val = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M6 26c6-8 12-8 18 0s12 8 18 0 12-8 16 0" />
      <path d="M6 40c6-8 12-8 18 0s12 8 18 0 12-8 16 0" />
    </g>
  </svg>
);

export const Knjiga = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M32 16v34" />
      <path d="M32 16C24 12 16 12 8 14v34c8-2 16-2 24 2" />
      <path d="M32 16c8-4 16-4 24-2v34c-8-2-16-2-24 2" />
    </g>
  </svg>
);

export const Srce = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M32 50S12 38 12 24a10 10 0 0 1 20-2 10 10 0 0 1 20 2c0 14-20 26-20 26z" />
    </g>
  </svg>
);

export const Travica = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      <path d="M10 54h44" />
      <path d="M22 54c-2-8-2-16 2-22M32 54c-2-10-2-20 2-28M42 54c-2-8-2-16 2-22" />
    </g>
  </svg>
);

export const Envelope = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <g {...base}>
      <rect x="3" y="6" width="18" height="12" rx="1.5" />
      <path d="M3 8l9 6 9-6" />
    </g>
  </svg>
);

export const ArrowRightThin = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <g {...base}><path d="M5 12h14M13 6l6 6-6 6" /></g>
  </svg>
);

export const CloseX = ({ size = 20, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <g {...base}><path d="M6 6l12 12M18 6L6 18" /></g>
  </svg>
);

export const MenuLines = ({ size = 22, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <g {...base}><path d="M4 7h16M4 12h16M4 17h16" /></g>
  </svg>
);

/* --- Editorial category icons (uniform stroke, olive tone via currentColor) --- */

// Baby bottle with milk-heart and clear nipple top — used for "Učiva se hranjenja"
export const Steklenicka = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Nipple */}
      <path d="M28 6h8v4h-8z" />
      <path d="M27 10h10v3H27z" />
      {/* Neck */}
      <path d="M25 13h14v4H25z" />
      {/* Body */}
      <path d="M23 17h18v34a6 6 0 0 1-6 6h-6a6 6 0 0 1-6-6z" />
      {/* Measurement marks */}
      <path d="M27 26h6M27 34h6M27 42h6" />
      {/* Milk heart */}
      <path d="M32 44s-4-3-4-6a2.4 2.4 0 0 1 4-1 2.4 2.4 0 0 1 4 1c0 3-4 6-4 6z" />
      {/* Steam lines top */}
      <path d="M20 4l-2 4M44 4l2 4M32 2v3" />
    </g>
  </svg>
);

// Female body silhouette (hourglass) — used for "Tvoje telo"
export const ZenskoTelo = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Head */}
      <circle cx="32" cy="12" r="5" />
      {/* Neck */}
      <path d="M32 17v3" />
      {/* Shoulders & upper body */}
      <path d="M20 24c2-3 6-4 12-4s10 1 12 4" />
      {/* Torso curves (hourglass) */}
      <path d="M22 24c-1 6 0 10 3 14c-1 4-2 8-1 12" />
      <path d="M42 24c1 6 0 10-3 14c1 4 2 8 1 12" />
      {/* Waist detail */}
      <path d="M27 40q5 3 10 0" />
      {/* Hips */}
      <path d="M24 50c-1 4 2 8 8 8s9-4 8-8" />
    </g>
  </svg>
);

// Two hands reaching toward each other with a small heart — used for "Povezanost"
export const DotikRok = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Left hand: wrist + palm + fingers reaching right */}
      <path d="M6 40c4-2 8-2 12 0" />
      <path d="M18 40c4 0 8 1 11 3" />
      <path d="M22 34c1-2 4-3 7-2l4 1" />
      <path d="M24 30c1-2 4-2 6-1l4 2" />
      <path d="M26 27c1-2 3-2 5-1l3 2" />
      {/* Right hand: mirrored */}
      <path d="M58 40c-4-2-8-2-12 0" />
      <path d="M46 40c-4 0-8 1-11 3" />
      <path d="M42 34c-1-2-4-3-7-2l-4 1" />
      <path d="M40 30c-1-2-4-2-6-1l-4 2" />
      <path d="M38 27c-1-2-3-2-5-1l-3 2" />
      {/* Small heart between fingertips */}
      <path d="M32 48s-3-2-3-5a1.8 1.8 0 0 1 3-0.8 1.8 1.8 0 0 1 3 0.8c0 3-3 5-3 5z" />
    </g>
  </svg>
);

// Pregnant belly / mother silhouette — used for "Prvi dnevi po porodu"
export const SrceZDojenckom = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Head */}
      <circle cx="30" cy="12" r="4" />
      <path d="M30 16v3" />
      {/* Shoulder & back */}
      <path d="M22 22c1-2 3-3 8-3" />
      <path d="M30 19c4 0 7 2 8 6" />
      {/* Back line */}
      <path d="M22 22c-2 8-2 20 2 32" />
      {/* Belly curve */}
      <path d="M38 25c8 4 10 12 8 20c-1 5-4 9-8 11" />
      {/* Small heart on belly */}
      <path d="M38 40s-3-2-3-5a1.8 1.8 0 0 1 3-0.8 1.8 1.8 0 0 1 3 0.8c0 3-3 5-3 5z" />
    </g>
  </svg>
);

// Curled newborn baby — used on home for "Želim bolje razumeti svoje telo" style card
export const Dojencek = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Head */}
      <circle cx="22" cy="20" r="8" />
      {/* Ear tuft */}
      <path d="M15 18q-2-1-2-4" />
      {/* Curled body */}
      <path d="M28 26c8 0 14 4 16 12s-2 14-10 14s-14-4-14-12" />
      {/* Legs curled */}
      <path d="M20 40c-2 4 0 8 4 10" />
      {/* Small heart on baby */}
      <path d="M32 40s-2.5-1.5-2.5-4a1.5 1.5 0 0 1 2.5-0.6 1.5 1.5 0 0 1 2.5 0.6c0 2.5-2.5 4-2.5 4z" />
    </g>
  </svg>
);

// Mother holding baby — used on home for "Po porodu želim ponovno zaupati…"
export const MamaZDojenckom = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Mom head */}
      <circle cx="24" cy="14" r="5" />
      {/* Hair line */}
      <path d="M19 12c0-4 3-6 5-6s5 2 5 6" />
      {/* Mom body & arms cradling baby */}
      <path d="M14 30c2-6 6-8 10-8s8 2 10 8" />
      <path d="M34 30c4 2 8 6 8 12c0 6-4 12-10 12h-14c-6 0-10-5-10-11c0-4 2-8 6-10" />
      {/* Baby head nestled */}
      <circle cx="36" cy="32" r="4" />
      {/* Baby blanket line */}
      <path d="M32 36q4 4 8 2" />
    </g>
  </svg>
);

// Coffee cup with heart — used on home for "Želim se ponovno povezati s sabo"
export const SkodelicaSrce = ({ size = 40, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g {...base}>
      {/* Steam */}
      <path d="M22 8c0-3 4-3 4-6M32 8c0-3 4-3 4-6M42 8c0-3 4-3 4-6" />
      {/* Cup */}
      <path d="M12 22h34v14a12 12 0 0 1-12 12h-10a12 12 0 0 1-12-12z" />
      {/* Handle */}
      <path d="M46 26h4a6 6 0 0 1 0 12h-4" />
      {/* Saucer */}
      <path d="M8 52h42" />
      {/* Heart on cup */}
      <path d="M29 34s-4-3-4-6a2.4 2.4 0 0 1 4-1 2.4 2.4 0 0 1 4 1c0 3-4 6-4 6z" />
    </g>
  </svg>
);


